var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      key: _vm.$route.fullPath,
      staticClass: "app-container-sitc",
      staticStyle: { "padding-bottom": "0px" },
    },
    [
      _c(
        "el-form",
        {
          ref: "filterForm",
          attrs: {
            rules: _vm.rules,
            "label-position": "top",
            model: _vm.filterForm,
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "filter-container-content",
              staticStyle: { "margin-top": "0" },
            },
            [
              _c(
                "el-breadcrumb",
                {
                  staticClass: "breadcrumb",
                  attrs: { "separator-class": "el-icon-arrow-right" },
                },
                [
                  _c("el-breadcrumb-item", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("roleCertificationApplication.roleApplication")
                      )
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 14 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "reqired",
                          attrs: {
                            label: _vm.$t(
                              "roleCertificationApplication.companyType"
                            ),
                            prop: "companyType",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: _vm.$t("home.select"),
                                disabled: _vm.isDisabled,
                                clearable: "",
                              },
                              model: {
                                value: _vm.filterForm.companyType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.filterForm, "companyType", $$v)
                                },
                                expression: "filterForm.companyType",
                              },
                            },
                            _vm._l(_vm.companyTypeList, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: {
                                  label:
                                    _vm.language === "zh"
                                      ? item.labelZh
                                      : item.labelEn,
                                  value: item.value,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "reqired",
                          attrs: {
                            label: _vm.$t(
                              "roleCertificationApplication.companyName"
                            ),
                            prop: "companyName",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { disabled: _vm.isDisabled },
                            model: {
                              value: _vm.filterForm.companyName,
                              callback: function ($$v) {
                                _vm.$set(_vm.filterForm, "companyName", $$v)
                              },
                              expression: "filterForm.companyName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "reqired",
                          class: {
                            reqired: _vm.isRequired,
                            "is-required": _vm.isRequired,
                          },
                          attrs: {
                            label: _vm.$t(
                              "roleCertificationApplication.companyNameEn"
                            ),
                            prop: "companyNameEn",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { disabled: _vm.isDisabled },
                            model: {
                              value: _vm.filterForm.companyNameEn,
                              callback: function ($$v) {
                                _vm.$set(_vm.filterForm, "companyNameEn", $$v)
                              },
                              expression: "filterForm.companyNameEn",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          class: {
                            reqired: _vm.isRequired,
                            "is-required": _vm.isRequired,
                          },
                          attrs: {
                            label: _vm.$t("roleCertificationApplication.usci"),
                            prop: "usci",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { disabled: _vm.isDisabled },
                            model: {
                              value: _vm.filterForm.usci,
                              callback: function ($$v) {
                                _vm.$set(_vm.filterForm, "usci", $$v)
                              },
                              expression: "filterForm.usci",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 14 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "reqired",
                          attrs: {
                            label: _vm.$t(
                              "roleCertificationApplication.companyAbbrev"
                            ),
                            prop: "companyAbbrev",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { disabled: _vm.isDisabled },
                            model: {
                              value: _vm.filterForm.companyAbbrev,
                              callback: function ($$v) {
                                _vm.$set(_vm.filterForm, "companyAbbrev", $$v)
                              },
                              expression: "filterForm.companyAbbrev",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "reqired",
                          attrs: {
                            label: _vm.$t(
                              "roleCertificationApplication.companyAddress"
                            ),
                            prop: "companyAddress",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { disabled: _vm.isDisabled },
                            model: {
                              value: _vm.filterForm.companyAddress,
                              callback: function ($$v) {
                                _vm.$set(_vm.filterForm, "companyAddress", $$v)
                              },
                              expression: "filterForm.companyAddress",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 14 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "reqired",
                          attrs: {
                            label: _vm.$t(
                              "roleCertificationApplication.country"
                            ),
                            prop: "country",
                          },
                        },
                        [
                          _c("glCountry", {
                            attrs: {
                              placeholder: _vm.$t("home.select"),
                              disabled: _vm.isDisabled,
                            },
                            model: {
                              value: _vm.filterForm.country,
                              callback: function ($$v) {
                                _vm.$set(_vm.filterForm, "country", $$v)
                              },
                              expression: "filterForm.country",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "roleCertificationApplication.province"
                            ),
                            prop: "province",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { disabled: _vm.isDisabled },
                            model: {
                              value: _vm.filterForm.province,
                              callback: function ($$v) {
                                _vm.$set(_vm.filterForm, "province", $$v)
                              },
                              expression: "filterForm.province",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("roleCertificationApplication.city"),
                            prop: "city",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { disabled: _vm.isDisabled },
                            model: {
                              value: _vm.filterForm.city,
                              callback: function ($$v) {
                                _vm.$set(_vm.filterForm, "city", $$v)
                              },
                              expression: "filterForm.city",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 14 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 3 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          class: {
                            reqired: _vm.isRequired,
                            "is-required": _vm.isRequired,
                          },
                          attrs: {
                            label: _vm.$t(
                              "roleCertificationApplication.businessLicenseScanningCopy"
                            ),
                            prop: "businessLicenseScanningCopy",
                          },
                        },
                        [
                          _c(
                            "el-upload",
                            {
                              ref: "upload",
                              staticClass: "upload-demo",
                              staticStyle: { width: "130px" },
                              attrs: {
                                action: "",
                                multiple: "",
                                limit: 1,
                                "http-request": function (file) {
                                  return _vm.uploadFile(file, "businessLicense")
                                },
                                "on-remove": function (file) {
                                  return _vm.handleRemove(
                                    file,
                                    "businessLicense"
                                  )
                                },
                                "file-list": _vm.uploadedBusinessLicenseFiles,
                                "on-preview": _vm.handleDownload,
                                "before-remove":
                                  _vm.beforeRemoveBusinessLicense,
                                accept: _vm.acceptList,
                              },
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  staticClass: "btn-primary",
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    icon: "el-icon-upload2",
                                    type: "primary",
                                    disabled:
                                      (_vm.isDisabled ||
                                        _vm.uploadedBusinessLicenseFiles
                                          .length > 0) &&
                                      (_vm.businessLicenseScanningCopyDisabled ||
                                        _vm.uploadedBusinessLicenseFiles
                                          .length > 0),
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t(
                                          "roleCertificationApplication.uploadAttachment"
                                        )
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 19 } }, [
                    _c("div", { staticClass: "button-container" }, [
                      _c("span", { staticClass: "container-content-tips" }, [
                        _vm._v(
                          _vm._s(_vm.$t("roleCertificationApplication.tips"))
                        ),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "filter-container-content" },
            [
              _c(
                "el-checkbox-group",
                {
                  attrs: { disabled: _vm.disabledEdit },
                  on: { change: _vm.handleCheckboxChange },
                  model: {
                    value: _vm.checkedFields,
                    callback: function ($$v) {
                      _vm.checkedFields = $$v
                    },
                    expression: "checkedFields",
                  },
                },
                _vm._l(_vm.sysRole, function (role) {
                  return _c(
                    "el-checkbox",
                    { key: role.sysRoleId, attrs: { label: role.roleCode } },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.language === "zh"
                              ? role.roleName
                              : role.roleNameEn
                          ) +
                          "\n        "
                      ),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.isChecked("BOOKING_JP")
            ? _c(
                "div",
                { staticClass: "filter-container-content" },
                [
                  _c(
                    "el-breadcrumb",
                    {
                      staticClass: "breadcrumb item-title",
                      attrs: { "separator-class": "el-icon-arrow-right" },
                    },
                    [
                      _c("el-breadcrumb-item", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("roleCertificationApplication.bookingJp")
                          )
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 14 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "reqired",
                              attrs: {
                                label: _vm.$t(
                                  "roleCertificationApplication.jpBookingForwarderCode"
                                ),
                                prop: "isBookingJP.jpBookingForwarderCode",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { clearable: "" },
                                  on: { change: _vm.handleSelectChange },
                                  model: {
                                    value:
                                      _vm.filterForm.isBookingJP
                                        .jpBookingForwarderCode,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.filterForm.isBookingJP,
                                        "jpBookingForwarderCode",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "filterForm.isBookingJP.jpBookingForwarderCode",
                                  },
                                },
                                _vm._l(_vm.bookingAgencies, function (item) {
                                  return _c("el-option", {
                                    key: item.dictItemId,
                                    attrs: {
                                      label:
                                        _vm.language === "zh"
                                          ? item.displayValueCn
                                          : item.displayValue,
                                      value: item.codeValue,
                                      "data-item": item,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "reqired",
                              attrs: {
                                label: _vm.$t(
                                  "roleCertificationApplication.contactMobilePhone"
                                ),
                                prop: "isBookingJP.contactMobilePhone",
                              },
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value:
                                    _vm.filterForm.isBookingJP
                                      .contactMobilePhone,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.filterForm.isBookingJP,
                                      "contactMobilePhone",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "filterForm.isBookingJP.contactMobilePhone",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "reqired",
                              attrs: {
                                label: _vm.$t(
                                  "roleCertificationApplication.faxNo"
                                ),
                                prop: "isBookingJP.faxNo",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { maxlength: "20" },
                                model: {
                                  value: _vm.filterForm.isBookingJP.faxNo,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.filterForm.isBookingJP,
                                      "faxNo",
                                      $$v
                                    )
                                  },
                                  expression: "filterForm.isBookingJP.faxNo",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c("div", { staticClass: "filter-label" }, [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "roleCertificationApplication.freightDeliveryMethod"
                                  )
                                )
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-checkbox",
                            {
                              attrs: { label: "Email", name: "type" },
                              model: {
                                value: _vm.emailCheckValue,
                                callback: function ($$v) {
                                  _vm.emailCheckValue = $$v
                                },
                                expression: "emailCheckValue",
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t(
                                      "roleCertificationApplication.emailCheck"
                                    )
                                  ) +
                                  "\n          "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-checkbox",
                            {
                              attrs: { label: "Fax", name: "type" },
                              model: {
                                value: _vm.faxCheckValue,
                                callback: function ($$v) {
                                  _vm.faxCheckValue = $$v
                                },
                                expression: "faxCheckValue",
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t(
                                      "roleCertificationApplication.faxCheck"
                                    )
                                  ) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 14 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "roleCertificationApplication.terms"
                                ),
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  autosize: { minRows: 2, maxRows: 6 },
                                  disabled: true,
                                },
                                model: {
                                  value:
                                    _vm.language === "zh"
                                      ? _vm.termContent
                                      : _vm.termContentEn,
                                  callback: function ($$v) {
                                    _vm.language === "zh"
                                      ? _vm.termContent
                                      : (_vm.termContentEn = $$v)
                                  },
                                  expression:
                                    "language ==='zh'? termContent: termContentEn",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 14 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c("div", { staticClass: "filter-label" }),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { prop: "agreedTerms" } },
                            [
                              _c("el-checkbox", {
                                attrs: {
                                  label: _vm.$t(
                                    "roleCertificationApplication.agreement"
                                  ),
                                  name: "type",
                                  "false-label": "",
                                },
                                model: {
                                  value: _vm.filterForm.agreedTerms,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filterForm, "agreedTerms", $$v)
                                  },
                                  expression: "filterForm.agreedTerms",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isChecked("BOOKING_NOT_JP")
            ? _c(
                "div",
                { staticClass: "filter-container-content" },
                [
                  _c(
                    "el-breadcrumb",
                    {
                      staticClass: "breadcrumb item-title",
                      attrs: { "separator-class": "el-icon-arrow-right" },
                    },
                    [
                      _c("el-breadcrumb-item", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("roleCertificationApplication.bookingNotJp")
                          )
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 14 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "reqired",
                              attrs: {
                                label: _vm.$t(
                                  "roleCertificationApplication.contactMobilePhone"
                                ),
                                prop: "isBookingNonJP.contactMobilePhone",
                              },
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value:
                                    _vm.filterForm.isBookingNonJP
                                      .contactMobilePhone,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.filterForm.isBookingNonJP,
                                      "contactMobilePhone",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "filterForm.isBookingNonJP.contactMobilePhone",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c("div", { staticClass: "filter-label" }, [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("roleCertificationApplication.taxNo")
                                )
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { prop: "isBookingNonJP.taxNo" } },
                            [
                              _c("el-input", {
                                attrs: { maxlength: "20" },
                                model: {
                                  value: _vm.filterForm.isBookingNonJP.taxNo,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.filterForm.isBookingNonJP,
                                      "taxNo",
                                      $$v
                                    )
                                  },
                                  expression: "filterForm.isBookingNonJP.taxNo",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c("div", { staticClass: "filter-label" }, [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("roleCertificationApplication.faxNo")
                                )
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { prop: "isBookingNonJP.faxNo" } },
                            [
                              _c("el-input", {
                                attrs: { maxlength: "20" },
                                model: {
                                  value: _vm.filterForm.isBookingNonJP.faxNo,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.filterForm.isBookingNonJP,
                                      "faxNo",
                                      $$v
                                    )
                                  },
                                  expression: "filterForm.isBookingNonJP.faxNo",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c("div", { staticClass: "filter-label" }, [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "roleCertificationApplication.freightDeliveryMethod"
                                  )
                                )
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-checkbox",
                            {
                              attrs: { label: "Email", name: "type" },
                              model: {
                                value: _vm.isNonEmailCheckValue,
                                callback: function ($$v) {
                                  _vm.isNonEmailCheckValue = $$v
                                },
                                expression: "isNonEmailCheckValue",
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t(
                                      "roleCertificationApplication.emailCheck"
                                    )
                                  ) +
                                  "\n          "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-checkbox",
                            {
                              attrs: { label: "Fax", name: "type" },
                              model: {
                                value: _vm.isNonFaxCheckValue,
                                callback: function ($$v) {
                                  _vm.isNonFaxCheckValue = $$v
                                },
                                expression: "isNonFaxCheckValue",
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t(
                                      "roleCertificationApplication.faxCheck"
                                    )
                                  ) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 14 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "reqired",
                              attrs: {
                                label: _vm.$t(
                                  "roleCertificationApplication.portCode"
                                ),
                                prop: "isBookingNonJP.portNameList",
                              },
                            },
                            [
                              _c("port-configuration", {
                                attrs: {
                                  disabled: _vm.disabledEdit,
                                  "role-code": "BOOKING_NOT_JP",
                                  multiple: "",
                                },
                                model: {
                                  value:
                                    _vm.filterForm.isBookingNonJP.portNameList,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.filterForm.isBookingNonJP,
                                      "portNameList",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "filterForm.isBookingNonJP.portNameList",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 14 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "roleCertificationApplication.terms"
                                ),
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  autosize: { minRows: 2, maxRows: 6 },
                                  disabled: true,
                                },
                                model: {
                                  value:
                                    _vm.language === "zh"
                                      ? _vm.termContent
                                      : _vm.termContentEn,
                                  callback: function ($$v) {
                                    _vm.language === "zh"
                                      ? _vm.termContent
                                      : (_vm.termContentEn = $$v)
                                  },
                                  expression:
                                    "language ==='zh'? termContent: termContentEn",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 14 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c("div", { staticClass: "filter-label" }),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { prop: "agreedTerms1" } },
                            [
                              _c("el-checkbox", {
                                attrs: {
                                  label: _vm.$t(
                                    "roleCertificationApplication.agreement"
                                  ),
                                  name: "type",
                                  "false-label": "",
                                },
                                model: {
                                  value: _vm.filterForm.agreedTerms1,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.filterForm,
                                      "agreedTerms1",
                                      $$v
                                    )
                                  },
                                  expression: "filterForm.agreedTerms1",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isChecked("IN_EDO")
            ? _c(
                "div",
                { staticClass: "filter-container-content" },
                [
                  _c(
                    "el-breadcrumb",
                    {
                      staticClass: "breadcrumb item-title",
                      attrs: { "separator-class": "el-icon-arrow-right" },
                    },
                    [
                      _c("el-breadcrumb-item", [
                        _vm._v(
                          _vm._s(_vm.$t("roleCertificationApplication.inEdo"))
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 14 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "reqired",
                              attrs: {
                                label: _vm.$t(
                                  "roleCertificationApplication.MobilePhone"
                                ),
                                prop: "isImportSwapBooking.contactMobilePhone",
                              },
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value:
                                    _vm.filterForm.isImportSwapBooking
                                      .contactMobilePhone,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.filterForm.isImportSwapBooking,
                                      "contactMobilePhone",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "filterForm.isImportSwapBooking.contactMobilePhone",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "reqired",
                              attrs: {
                                label: _vm.$t(
                                  "roleCertificationApplication.contactPhone"
                                ),
                                prop: "isImportSwapBooking.contactPhone",
                              },
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value:
                                    _vm.filterForm.isImportSwapBooking
                                      .contactPhone,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.filterForm.isImportSwapBooking,
                                      "contactPhone",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "filterForm.isImportSwapBooking.contactPhone",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "reqired",
                              attrs: {
                                label: _vm.$t(
                                  "roleCertificationApplication.portCode"
                                ),
                                prop: "isImportSwapBooking.portCode",
                              },
                            },
                            [
                              _c("port-configuration-p-h", {
                                attrs: {
                                  disabled: _vm.disabledEdit,
                                  "role-code": "IN_EDO",
                                  multiple: true,
                                },
                                on: { change: _vm.updateCustomerTypeRule },
                                model: {
                                  value:
                                    _vm.filterForm.isImportSwapBooking.portCode,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.filterForm.isImportSwapBooking,
                                      "portCode",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "filterForm.isImportSwapBooking.portCode",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 14 } },
                    [
                      _vm.filterForm.isImportSwapBooking.portCode &&
                      Array.isArray(
                        _vm.filterForm.isImportSwapBooking.portCode
                      ) &&
                      !_vm.filterForm.isImportSwapBooking.portCode.includes(
                        "CNNSA"
                      ) &&
                      !_vm.filterForm.isImportSwapBooking.portCode.includes(
                        "CNYPG"
                      )
                        ? _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  class: {
                                    reqired:
                                      _vm.filterForm.isImportSwapBooking
                                        .portCode &&
                                      Array.isArray(
                                        _vm.filterForm.isImportSwapBooking
                                          .portCode
                                      ) &&
                                      _vm.filterForm.isImportSwapBooking.portCode.some(
                                        function (code) {
                                          return code !== "CNXMN"
                                        }
                                      ),
                                  },
                                  attrs: {
                                    label: _vm.$t(
                                      "roleCertificationApplication.importEdoPromise"
                                    ),
                                    prop: "isImportSwapBooking.edoRecordFileId",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "align-items": "center",
                                        gap: "10px",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-upload",
                                        {
                                          ref: "upload",
                                          staticClass: "upload-demo",
                                          attrs: {
                                            action: "",
                                            multiple: "",
                                            limit: 1,
                                            "http-request": function (file) {
                                              return _vm.uploadFile(file, "edo")
                                            },
                                            "on-remove": function (file) {
                                              return _vm.handleRemove(
                                                file,
                                                "edo"
                                              )
                                            },
                                            "before-remove": _vm.beforeRemove,
                                            "file-list":
                                              _vm.uploadedEdoRecordFiles,
                                            "on-preview": _vm.handleDownload,
                                            accept: _vm.acceptList,
                                          },
                                        },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              staticClass: "btn-primary",
                                              attrs: {
                                                icon: "el-icon-upload2",
                                                type: "primary",
                                                disabled:
                                                  _vm.uploadedEdoRecordFiles
                                                    .length > 0,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "roleCertificationApplication.uploadAttachment"
                                                    )
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm.filterForm.isImportSwapBooking
                                        .portCode &&
                                      Array.isArray(
                                        _vm.filterForm.isImportSwapBooking
                                          .portCode
                                      ) &&
                                      _vm.filterForm.isImportSwapBooking
                                        .portCode.length > 0
                                        ? _c(
                                            "a",
                                            {
                                              staticStyle: {
                                                color: "blue",
                                                "text-decoration": "underline",
                                                "white-space": "nowrap",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.downloadEdoPromise(
                                                    _vm.filterForm
                                                      .isImportSwapBooking
                                                      .portCode[0]
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "roleCertificationApplication.importEdoPromise"
                                                    )
                                                  ) +
                                                  "\n              "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _vm.filterForm.isImportSwapBooking.portCode &&
                          Array.isArray(
                            _vm.filterForm.isImportSwapBooking.portCode
                          ) &&
                          _vm.filterForm.isImportSwapBooking.portCode.some(
                            function (code) {
                              return code && code.startsWith("PH")
                            }
                          )
                            ? _c(
                                "el-form-item",
                                {
                                  staticClass: "reqired",
                                  attrs: {
                                    label: _vm.$t(
                                      "roleCertificationApplication.customerType"
                                    ),
                                    prop: "isImportSwapBooking.customerType",
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: { clearable: "" },
                                      model: {
                                        value:
                                          _vm.filterForm.isImportSwapBooking
                                            .customerType,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.filterForm.isImportSwapBooking,
                                            "customerType",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "filterForm.isImportSwapBooking.customerType",
                                      },
                                    },
                                    _vm._l(
                                      _vm.customerTypeList,
                                      function (item) {
                                        return _c("el-option", {
                                          key: item.value,
                                          attrs: {
                                            label:
                                              _vm.language === "zh"
                                                ? item.labelZh
                                                : item.labelEn,
                                            value: item.value,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isChecked("OUT_DG_DEC")
            ? _c(
                "div",
                { staticClass: "filter-container-content" },
                [
                  _c(
                    "el-breadcrumb",
                    {
                      staticClass: "breadcrumb item-title",
                      attrs: { "separator-class": "el-icon-arrow-right" },
                    },
                    [
                      _c("el-breadcrumb-item", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("roleCertificationApplication.outDgDec")
                          )
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 14 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "roleCertificationApplication.edoUnitType"
                                ),
                                prop: "isExportDangerousGoodsDeclaration.edoUnitType",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { clearable: "" },
                                  model: {
                                    value:
                                      _vm.filterForm
                                        .isExportDangerousGoodsDeclaration
                                        .edoUnitType,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.filterForm
                                          .isExportDangerousGoodsDeclaration,
                                        "edoUnitType",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "filterForm.isExportDangerousGoodsDeclaration.edoUnitType",
                                  },
                                },
                                _vm._l(_vm.edoUnitTypeList, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label:
                                        _vm.language === "zh"
                                          ? item.labelZh
                                          : item.labelEn,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "roleCertificationApplication.edoUserName"
                                ),
                                prop: "isExportDangerousGoodsDeclaration.edoUserName",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { maxlength: "20" },
                                model: {
                                  value:
                                    _vm.filterForm
                                      .isExportDangerousGoodsDeclaration
                                      .edoUserName,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.filterForm
                                        .isExportDangerousGoodsDeclaration,
                                      "edoUserName",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "filterForm.isExportDangerousGoodsDeclaration.edoUserName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "roleCertificationApplication.edoUserIdNumber"
                                ),
                                prop: "isExportDangerousGoodsDeclaration.edoUserIdNumber",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { maxlength: "20" },
                                model: {
                                  value:
                                    _vm.filterForm
                                      .isExportDangerousGoodsDeclaration
                                      .edoUserIdNumber,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.filterForm
                                        .isExportDangerousGoodsDeclaration,
                                      "edoUserIdNumber",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "filterForm.isExportDangerousGoodsDeclaration.edoUserIdNumber",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop: "isExportDangerousGoodsDeclaration.edoEmail",
                                label: _vm.$t(
                                  "roleCertificationApplication.edoEmail"
                                ),
                              },
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value:
                                    _vm.filterForm
                                      .isExportDangerousGoodsDeclaration
                                      .edoEmail,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.filterForm
                                        .isExportDangerousGoodsDeclaration,
                                      "edoEmail",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "filterForm.isExportDangerousGoodsDeclaration.edoEmail",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 14 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "roleCertificationApplication.contactMobilePhone"
                                ),
                                prop: "isExportDangerousGoodsDeclaration.contactMobilePhone",
                              },
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value:
                                    _vm.filterForm
                                      .isExportDangerousGoodsDeclaration
                                      .contactMobilePhone,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.filterForm
                                        .isExportDangerousGoodsDeclaration,
                                      "contactMobilePhone",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "filterForm.isExportDangerousGoodsDeclaration.contactMobilePhone",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "reqired",
                              attrs: {
                                label: _vm.$t(
                                  "roleCertificationApplication.portCode"
                                ),
                                prop: "isExportDangerousGoodsDeclaration.portNameList",
                              },
                            },
                            [
                              _c("port-configuration", {
                                attrs: {
                                  disabled: _vm.disabledEdit,
                                  "role-code": "OUT_DG_DEC",
                                  multiple: "",
                                },
                                model: {
                                  value:
                                    _vm.filterForm
                                      .isExportDangerousGoodsDeclaration
                                      .portNameList,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.filterForm
                                        .isExportDangerousGoodsDeclaration,
                                      "portNameList",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "filterForm.isExportDangerousGoodsDeclaration.portNameList",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "filter-container-content center-button" },
            [
              _c(
                "el-button",
                {
                  staticClass: "btn-primary",
                  attrs: { type: "primary" },
                  on: { click: _vm.onSubmit },
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("roleCertificationApplication.confirm")) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }